/**
 * 通用的 Toast 工具函数
 * 提供统一的成功、错误、警告、信息提示方法
 */

import { toast as sonnerToast } from "sonner";

// 通用样式配置
const commonToastStyle = {
  style: {
    background: "rgba(0, 0, 0, 0.85)",
    color: "#ffffff",
    fontSize: "14px",
    padding: "8px 12px",
    maxWidth: "350px",
    width: "fit-content",
    minWidth: "auto",
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

/**
 * 显示成功提示
 * @param message - 提示消息
 * @param options - 可选配置
 */
export const showSuccess = (
  message: string,
  options?: {
    duration?: number;
    id?: string | number;
  }
) => {
  return sonnerToast.success(message, {
    position: "top-center",
    duration: options?.duration || 1000,
    // ...commonToastStyle,
    ...options,
  });
};

/**
 * 显示错误提示
 * @param message - 提示消息
 * @param options - 可选配置
 */
export const showError = (
  message: string,
  options?: {
    duration?: number;
    id?: string | number;
  }
) => {
  return sonnerToast.error(message, {
    position: "top-center",
    duration: options?.duration || 1000,
    // ...commonToastStyle,
    ...options,
  });
};

/**
 * 显示警告提示
 * @param message - 提示消息
 * @param options - 可选配置
 */
export const showWarning = (
  message: string,
  options?: {
    duration?: number;
    id?: string | number;
  }
) => {
  return sonnerToast.warning(message, {
    position: "top-center",
    duration: options?.duration || 1000,
    // ...commonToastStyle,
    ...options,
  });
};

/**
 * 显示信息提示
 * @param message - 提示消息
 * @param options - 可选配置
 */
export const showInfo = (
  message: string,
  options?: {
    duration?: number;
    id?: string | number;
  }
) => {
  return sonnerToast.info(message, {
    position: "top-center",
    duration: options?.duration || 1000,
    // ...commonToastStyle,
    ...options,
  });
};

/**
 * 显示加载提示
 * @param message - 提示消息
 * @param id - 提示 ID，用于后续关闭
 */
export const showLoading = (message: string, id?: string | number) => {
  return sonnerToast.loading(message, {
    position: "top-center",
    // ...commonToastStyle,
    id,
  });
};

/**
 * 关闭指定的提示
 * @param id - 提示 ID
 */
export const dismissToast = (id?: string | number) => {
  sonnerToast.dismiss(id);
};

/**
 * 关闭所有提示
 */
export const dismissAll = () => {
  sonnerToast.dismiss();
};

// 导出原始的 toast 对象，以便需要更多自定义时使用
export { sonnerToast as toast };
